import { GraphQLClient } from "graphql-request";

const GRAPHQL_ENDPOINT = import.meta.env.VITE_COOLER_METRICS_SUBGRAPH;

export const graphqlClient = new GraphQLClient(GRAPHQL_ENDPOINT);
